import {setStoredAuthToken} from "shared/utils/authSession";
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    decodeAuthTokenClaims,
    getAuthenticatedHomePath,
    isUserAccountsSession,
} from "shared/utils/userAccountSession";
import {API_URL, IS_JAMPA} from "shared/api/client";
import {completeLocalStageGoogleLogin, LOCAL_AUTH_ERROR, readLocalStageGoogleCallback} from "./localStageGoogleAuth";
import "./GoogleLogin.css";

const AuthCallback: React.FC = () => {
    const navigate = useNavigate();
    const localCallback = useRef(readLocalStageGoogleCallback(window.location.hash));
    const [localError, setLocalError] = useState<string | null>(null);

    useEffect(() => {
        const cleanUrl = new URL(window.location.href);
        const unsolicitedToken = cleanUrl.searchParams.has("token");
        cleanUrl.hash = "";
        cleanUrl.searchParams.delete("token");
        window.history.replaceState(window.history.state, "", `${cleanUrl.pathname}${cleanUrl.search}`);
        if (localCallback.current) {
            const callback = localCallback.current;
            let active = true;
            completeLocalStageGoogleLogin(callback, API_URL).then(token => {
                if (!active) return;
                const decoded = decodeAuthTokenClaims(token);
                const now = Math.floor(Date.now() / 1000);
                if (!decoded?.exp || now >= decoded.exp - 5 * 60) throw new Error(LOCAL_AUTH_ERROR);
                if (!isUserAccountsSession(decoded)) throw new Error("יש להתחבר מחדש כדי להיכנס לסביבת העבודה.");
                setStoredAuthToken(token);
                navigate(getAuthenticatedHomePath(decoded), {replace: true});
            }).catch(error => {
                if (active) setLocalError(error instanceof Error ? error.message : LOCAL_AUTH_ERROR);
            });
            return () => { active = false; };
        }

        // Bare bearer links are not proof that this tab initiated a login.
        // Leave any existing session intact when rejecting an unsolicited callback.
        if (unsolicitedToken) {
            setLocalError(LOCAL_AUTH_ERROR);
            return;
        }
        navigate("/login", {replace: true});
    }, [navigate]);

    if (!localCallback.current && !localError) return null;
    return (
        <div className={IS_JAMPA ? "login-container-jampa" : "login-container"} dir="rtl">
            <div className="login-card">
                <h2 className="login-title">{localError ? "ההתחברות לא הושלמה" : "משלימים את ההתחברות…"}</h2>
                {localError ? <>
                    <p className="login-error" role="alert">{localError}</p>
                    <button type="button" className="google-login" onClick={() => navigate("/login", {replace: true})}>
                        חזרה לכניסה עם Google
                    </button>
                </> : <p className="login-info" role="status">נא להמתין רגע.</p>}
            </div>
        </div>
    );
};

export default AuthCallback;
